import script from "./MysticDraft.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticDraft.vue?vue&type=script&setup=true&lang=js"

import "./MysticDraft.vue?vue&type=style&index=0&id=e5b0d538&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5b0d538"]])

export default __exports__